function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Slideshow_svg__clip0_1818_35808)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5.781H7.253A1.722 1.722 0 005.534 2.5v.469h-.468a1.722 1.722 0 00-1.72 1.719v.846H2.5a1.722 1.722 0 00-1.719 1.72V17.5A1.722 1.722 0 002.5 19.219h10.247a1.722 1.722 0 001.719-1.719v-.85h.847a1.722 1.722 0 001.718-1.719v-.465h.469a1.721 1.721 0 001.719-1.72V2.5A1.722 1.722 0 0017.5.781zm-15 17.5a.781.781 0 01-.781-.781v-2.006l3.125-3.125 5.937 5.937-8.281-.025zm3.612-9.193a1.772 1.772 0 113.544-.007 1.772 1.772 0 01-3.544.007zm7.416 8.412a.781.781 0 01-.781.781h-.625l-3.006-3.006 1.462-1.466 2.963 2.963-.013.728zm2.566-2.569a.782.782 0 01-.782.782h-.846v-8.46a1.722 1.722 0 00-1.72-1.719H4.285v-.846a.781.781 0 01.782-.782h10.247a.781.781 0 01.78.781v10.244z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Slideshow_svg__clip0_1818_35808"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgSlideshow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSlideshow;